import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import ProjectListComponent from "../../../components/Definition/Project/ProjectListComponent";
import { deleteProject, getProject } from "../../../actions/project/projects";
import { deleteDestination } from "../../../actions/destination/destination";

export default function ProjectScreen() {
    const [project, setProject] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getProject({page:params.toString()});
                setLoading(false);
                setProject(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <ProjectListComponent lists={project} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید پروژه حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteProject(id);
                    if (response.status === "success") {
                        toast.success("پروژه حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف پروژه");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
